(function() {
  'use strict';

  angular
    .module('factories.navigationFactory', [
      'factories.utils',
      'factories.authProvider',
      'factories.mobileHelper',
      'factories.spinnerHelper',
      'services.sension'])
    .factory('Navigation', Navigation);

  Navigation.$inject = ['$location', 'Utils', 'Auth', 'MobileHelper', 'SpinnerHelper', 'Sension', 'SessionExpiration',
    'mtypes', '$window', '$timeout'];

  function Navigation($location, Utils, Auth, MobileHelper, SpinnerHelper, Sension, SessionExpiration, mtypes, $window, $timeout) {
    var playerTypes = {
      trainee: 'trainee',
      trainerAsUserPreview: 'trainerAsUserPreview',
      trainerPreview: 'trainerPreview',
      trainerPreviewGoodData: 'trainerPreviewGoodData',
      smePreview: 'smePreview',
      public: 'public'
    };
    var nextCModuleUrl = '';
    var service = injectInterceptors({
      init: init,
      canNavigate: canNavigate,
      navigate: navigate,
      reset: reset,
      hideLeftArrow: hideLeftArrow,
      setNextCModuleUrl: setNextCModuleUrl,
      resetNextCModuleUrl: resetNextCModuleUrl
    });
    var directions = service.directions = { next: 'next', previous: 'previous', exit: 'exit' };
    var states = service.states = { loading: 'loading', ready: 'ready' };
    var interceptors = {};

    _.extend(service, {
      canNavigatePrevious: service.canNavigate.bind(service, directions.previous),
      canNavigateNext: service.canNavigate.bind(service, directions.next),
      navigatePrevious: service.navigate.bind(service, directions.previous),
      navigateNext: service.navigate.bind(service, directions.next),
      exitPlayer: service.navigate.bind(service, directions.exit),
      resetInterceptors: resetInterceptors,
      intercept: intercept,
      showNavControls: false,
      playerTypes: playerTypes
    });

    return service;

    //////////////

    function reset() {
      init({ numUnlockedSlides: -1, numSlides: 0 });
    }

    function init(params) {
      var currentSlideIndex = params.numUnlockedSlides;
      var numSlides = params.numSlides;
      var playerType = params.playerType;

      _.extend(service, {
        slideIndex: currentSlideIndex,
        numSlides: numSlides,
        numUnlockedSlides: getNumUnlockedSlides(playerType, params.cModuleStateStatus, numSlides, currentSlideIndex),
        isPreview: getIsPreview(playerType),
        freeNavigation: getFreeNavigation(playerType),
        state: states.loading,
        playerType: playerType,
        completionRedirectURL: params.completionRedirectUrl
      });
      updateUnlockedSlides();
      resetInterceptors();
      if (hideAllControls()) {
        topAlignTheContents();
      }
    }

    function getNumUnlockedSlides(pt, cModuleStateStatus, numSlides, currentSlideIndex) {
      return pt === playerTypes.trainerPreview || cModuleStateStatus === mtypes.cModuleStateStatus.completed ?
        numSlides : currentSlideIndex;
    }

    function getIsPreview(pt) {
      return pt === playerTypes.trainerPreview ||
        pt === playerTypes.trainerPreviewGoodData ||
        pt === playerTypes.smePreview ||
        pt === playerTypes.public;
    }

    function getFreeNavigation(pt) {
      return pt === playerTypes.trainerPreview || pt === playerTypes.trainerPreviewGoodData;
    }

    function setNextCModuleUrl(value) {
      nextCModuleUrl = value || '';
    }

    function resetNextCModuleUrl() {
      nextCModuleUrl = '';
    }

    function topAlignTheContents() {
      var fn = function() {
        var el = angular.element('#slideOuter');
        if (el.length === 0) {
          $timeout(fn, 100);
          return;
        }
        el.css('vertical-align', 'top');
      };
      fn();
    }

    // Can pass 'next', 'previous', 'exit' or a slide index
    function mapNavigateToLocation(navigateTo) {
      if (_.isNumber(navigateTo)) {
        return navigateTo;
      }

      if (['next', 'previous', 'exit'].indexOf(navigateTo) === -1) {
        return -1;
      }

      return {
        previous: function() {
          return service.slideIndex - 1;
        },
        next: function() {
          return service.slideIndex + 1 < service.numSlides ? service.slideIndex + 1 : directions.exit;
        },
        exit: function() {
          return directions.exit;
        }
      }[navigateTo]();
    }

    function hideAllControls() {
      return $location.absUrl().indexOf('hideNavigationControls=1') !== -1;
    }

    function canNavigate(navigateTo) {
      var destIdx;
      if (hideAllControls()) {
        return false;
      }

      if (service.playerType === playerTypes.trainerPreviewGoodData) {
        return false;
      }

      if (service.state !== states.ready) {
        return false;
      }

      destIdx = mapNavigateToLocation(navigateTo);

      return !_.isNumber(destIdx) || (destIdx >= 0 && destIdx < service.numSlides);
    }

    function navigate(navigateTo) {
      var newLoc;
      if (!service.canNavigate(navigateTo)) {
        return false;
      }

      SessionExpiration.resetIdleTimer();

      newLoc = mapNavigateToLocation(navigateTo);
      if (newLoc === directions.exit) {
        Sension.turnOff();

        if (service.playerType === playerTypes.public) {
          Utils.viewUrlInBrowser(service.completionRedirectURL);
        } else if (service.playerType === playerTypes.smePreview) {
          Auth.logout();
        } else if (service.playerType === playerTypes.trainerPreview && !MobileHelper.isNativeIpadApp) {
          $window.close();
        } else if (nextCModuleUrl !== '') {
          $window.location = nextCModuleUrl;
        } else {
          SpinnerHelper.showLoadingSpinner();
          $window.location = mfConfig.dashUrl;
        }

        return true;
      }

      service.slideIndex = newLoc;
      updateUnlockedSlides();
      return true;
    }

    function updateUnlockedSlides() {
      service.numUnlockedSlides = Math.max(service.numUnlockedSlides || 0, service.slideIndex + 1);
    }

    function intercept(name, fn) {
      interceptors[name] = interceptors[name] || [];
      interceptors[name].push(fn);
    }

    function resetInterceptors() {
      interceptors = {};
      service.resetNextCModuleUrl();
    }

    function injectInterceptors(obj) {
      _.each(obj, function(fn, key) {
        obj[key] = runWithInterceptors.bind(obj, key, fn);
      });
      return obj;
    }

    function runWithInterceptors(name, fn) {
      var args = _.rest(arguments, 2);
      if (!runInterceptors(name, args)) {
        return false;
      }

      return fn.apply(null, args);
    }

    function runInterceptors(name, args) {
      var fns = interceptors[name];
      var i;
      if (!fns) {
        return true;
      }

      for (i = 0; i < fns.length; i++) {
        if (!fns[i].apply(null, args)) {
          return false;
        }
      }

      return true;
    }

    function hideLeftArrow() {
      return service.slideIndex === 0 || service.slideIndex === undefined || !canNavigate(directions.previous);
    }
  }
})();
